/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Wewillberightback4Inputs */

const en_help_wewillberightback4 = /** @type {(inputs: Help_Wewillberightback4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We will be right back`)
};

/**
* | output |
* | --- |
* | "We will be right back" |
*
* @param {Help_Wewillberightback4Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const help_wewillberightback4 = /** @type {((inputs?: Help_Wewillberightback4Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Wewillberightback4Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_wewillberightback4(inputs)
});
export { help_wewillberightback4 as "help_weWillBeRightBack" }